// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","container":"Main_container__Bgy4k","shopItem":"Main_shopItem__Wbo5d","similar":"Main_similar__dKze7","list":"Main_list__wzrx8"};